import Computer from "@material-ui/icons/Computer";
import School from "@material-ui/icons/School";
import SpeakerNotes from "@material-ui/icons/SpeakerNotes";
import React, { FC } from "react";
import { ExamSessionViewModel } from "../../model/ExamSessionViewModel";
import { RoomAssignmentViewModel } from "../../model/RoomAssignmentViewModel";
import CustomCard from "../common/CustomCard";
import LanguageList from "../common/language/LanguageList";
import ExamChips from "../exam/ExamChips";
import TranslatedMessage from "../translations/TranslatedMessage";

type RoomAssignmentCardProps = {
  examSession: ExamSessionViewModel;
  isReadOnly: boolean;
  isUserRoomAssignment?: boolean;
  locationId: string;
  roomAssignment: RoomAssignmentViewModel;
  onDeleteRoomAssignment?: (roomAssignmentId: string) => void;
};

const RoomAssignmentCard: FC<RoomAssignmentCardProps> = ({
  examSession,
  isReadOnly,
  isUserRoomAssignment,
  roomAssignment,
  locationId,
  onDeleteRoomAssignment,
}) => {
  const location = examSession.locations.find((location) => location.id === locationId);
  if (location === undefined) {
    return <></>;
  }

  const handleDelete = () => {
    if (isReadOnly && !roomAssignment.isPreparationRoom) {
      return () => {};
    }

    return onDeleteRoomAssignment!(roomAssignment.id);
  };

  const getRoomAssignmentIcon = () => {
    if (roomAssignment.isPreparationRoom) {
      return <School />;
    }
    if (room && room.isPcRoom) {
      return <Computer />;
    }

    return <SpeakerNotes />;
  };

  const getExams = () => {
    const examIds = roomAssignment.examAssignments.map((assignment) => assignment.examId);
    return examSession.exams.filter((exam) => examIds.indexOf(exam.id) > -1);
  };

  const exams = getExams();
  const room = location.rooms.find((room) => room.id === roomAssignment.roomId);
  const roomAssignmentIcon = getRoomAssignmentIcon();
  const floor = room !== undefined ? room.floor : "";
  const numberOfSeats = room !== undefined ? room.numberOfSeats : 0;
  const languagesElement = <LanguageList languageRegions={roomAssignment.languages} />;
  const examsElement = <ExamChips exams={exams} />;
  const deleteConfirmationContent = roomAssignment.isPreparationRoom ? (
    <TranslatedMessage id="roomAssignment.deleteConfirmation.title" />
  ) : undefined;

  return (
    <CustomCard
      onDelete={handleDelete}
      isCardClickDisabled={true}
      isDeleteButtonVisible={(!isReadOnly || roomAssignment.isPreparationRoom) && !isUserRoomAssignment}
      line1={location.name}
      line2={
        <span>
          {room && room.name} {roomAssignmentIcon}
        </span>
      }
      line3={
        <span>
          <TranslatedMessage id="room.field.floor" /> {floor} - {numberOfSeats}{" "}
          <TranslatedMessage id="room.text.seats" />
        </span>
      }
      restLines={[languagesElement, examsElement]}
      deleteConfirmationContent={deleteConfirmationContent}
    />
  );
};

export default RoomAssignmentCard;
